import { GraphQLError } from '@tableau/data-catalog-client-components';

type ErrorStore = {
  addError: (error: GraphQLError) => void;
};


let registeredErrorStore: ErrorStore | null = null;

export function registerErrorStore(errorStore: ErrorStore) {
  registeredErrorStore = errorStore;
}

export function unregisterErrorStore() {
  registeredErrorStore = null;
}


/**
 * Global "service" that allows components within VizPortal Client (such as the Tables/Databases explorer resource queries)
 * to report Data Catalog errors.
 *
 * A single errorStore at a time can register to receivethe errors. In practice, the error store is
 * part of the data-catalog-client-components, and stores/renders the errors within the data catalog code.
 */
export function reportGraphQLError(error: GraphQLError) {
  if (registeredErrorStore) {
    registeredErrorStore.addError(error);
  }
}
